module.exports = __webpack_public_path__ + "media/future-mask-off-official-music-video.44c66c72.mp3";